module.exports = __webpack_public_path__ + "img/buy.01aea47c.png";